<section class="gallery">

   <img class="epk-photo one" src="https://res.cloudinary.com/dadqp2oia/image/upload/v1629671571/Music%20Website/ElyzaBleau-nightPortrait-1-lowRes_bwq0h2.png" alt="portrait of Elyza at night" download>

    <img class="epk-photo two" src="https://res.cloudinary.com/dadqp2oia/image/upload/v1629671571/Music%20Website/ElyzaBleau-fullBody-Portrait-lowRes_ighsx0.png" alt="portrait of Elyza full body" download>

</section>

